import { useSyncExternalStore } from 'react';
const semAssinatura = () => () => undefined;

/**
 * `false` na renderização do servidor e na de hidratação, `true` a partir da renderização
 * seguinte. Serve para o que só pode ser calculado com o DOM do browser (sanitizar HTML com o
 * DOMPurify): a hidratação não corrige `innerHTML` que divergiu do servidor, então o conteúdo
 * tem de nascer vazio dos dois lados e ser preenchido depois.
 *
 * @example const hidratado = useHidratado(); return hidratado ? <Conteudo /> : null;
 */
export function useHidratado() {
  return useSyncExternalStore(semAssinatura, _temp, _temp2);
}
function _temp2() {
  return false;
}
function _temp() {
  return true;
}